import React from 'react'

import { Form, Col } from '_zari/core'

import { TiposSocioConstant } from 'constants/index'

const TipoSocioFormGroup = ({ iValue, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO SOCIO' htmlFor='radio-tiposocio' md={4} alignRightAt='md' />
      <Col md={8}>
        {TiposSocioConstant.__array.map(x => (
          <Form.Radio
            key={x.id}
            id={`radio-tiposocio-${x.id}`}
            name='radio-tipoSocio'
            label={x.nombre}
            value={x.id}
            checked={iValue === x.id}
            onClick={() => onChange(x.id)}
          />
        ))}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoSocioFormGroup)
